import React, { useMemo } from "react";
import GenericPullConfigListing from "../GenericPullConfigListing";
import MeterianCredentialsForm from "./MeterianCredentialsForm";
import MeterianMappingForm from "./MeterianMappingForm";
import { columnRenderArrayData } from "utils/tableUtils";
const DELIMITER = ";";
export default function MeterianConfigListing(props) {
  const columns = useMemo(
    () => [
      {
        title: "Project",
        dataIndex: "projectName",
        width: 240,
        render: (projectName, record) => {
          const projectNames = renderProjectorBranchName(
            projectName,
            "project"
          );
          return projectNames;
        },
      },
      {
        title: "Branch",
        dataIndex: "branch",
        render: (branch, record) => {
          const branchNames = renderProjectorBranchName(
            record.projectName,
            "branch"
          );
          return branchNames;
        },
        width: 240,
      },
    ],
    []
  );
  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={MeterianMappingForm}
      CredentialsForm={MeterianCredentialsForm}
      extraColumns={columns}
      displayComponentName="Project"
    />
  );
}

const renderProjectorBranchName = (name, type) => {
  const projectNames = name
    .split(",")
    .map((i) => i.split(DELIMITER)[type === "branch" ? 1 : 0])
    .join();
  return columnRenderArrayData(projectNames);
};
